import React,{useState} from 'react'
import {BiCheckbox} from 'react-icons/bi'
import {IoMdCheckboxOutline} from 'react-icons/io'

const ElectionCard = ({candidates,position}) => {
    
  return (
    <div
    className='bg-blue text-white font-semibold w-full rounded-sm shadow-sm shadow-dark py-1 px-2'
    >
        <h2>{position}</h2>
        <div className='grid gap-4 mt-2'>
            {candidates.map((d,i) => {
                return(
                    <label 
                    key={i}
                    className='flex items-center justify-between border-b-2 pb-1 hover:bg-dark/40'>
                        <div className='flex items-center space-x-5'>
                            <img 
                            className='w-8 rounded-full h-8 shadow-sm shadow-dark'
                            src={d.image} alt={d.name} />
                            <p>{d.name}</p>
                        </div>
                        <input
                        type='radio'
                        value={d.identity}
                        name={position}
                        />
                    </label>
                )
            })}
        </div>

    </div>
  )
}

export default ElectionCard